<template>
  <div class="alliance-news-view">
    <NavBar/>
    <AllianceNews />
  </div>
</template>

<script>
// @ is an alias to /src
import NavBar from '@/components/NavBar';
import AllianceNews from '@/components/AllianceNews.vue'

export default {
  name: 'AllianceNewsView',
  components: {
    NavBar,
    AllianceNews
  }
}
</script>

<style lang="scss" scoped>
.alliance-news-view {
  min-height: 100vh;
}
</style>
